module.exports = __webpack_public_path__ + "img/ConditionsReport-Things-To-Do-desktop.jpg";